import { Link } from 'react-router-dom';
import FAQSection from '../FAQSection';
import '../Homepage/FAQ.css';

const SFPFaq = () => {
  const faqs = [
    {
      id: 1,
      question: 'What are the benefits of Seller Fulfilled Prime?',
      answer: (
        <>
          Seller Fulfilled Prime keeps the Prime badge while you avoid FBA storage fees and restock limits, and
          supports omni-channel fulfilment across eBay, TikTok,{' '}
          <Link to="/shopify-fulfillment-services">Shopify</Link> and more from one warehouse. Full breakdown:{' '}
          <Link to="/blog/what-is-seller-fulfilled-prime-uk-complete-guide-2026">
            what is Seller Fulfilled Prime UK
          </Link>
          .
        </>
      ),
    },
    {
      id: 2,
      question: 'Why choose SFP over FBA?',
      answer: (
        <>
          SFP suits brands that want control, lower storage risk, and multi-channel selling. Compare models in{' '}
          <Link to="/blog/sfp-vs-fba-2026">SFP vs FBA 2026</Link> or our{' '}
          <Link to="/blog/seller-fulfilled-prime-vs-fba">Seller Fulfilled Prime vs FBA</Link> explainer — FBA
          can still suit very high volumes, while SFP with Pick Pack Pro is typically more flexible.
        </>
      ),
    },
    {
      id: 3,
      question: 'How do I get the Prime badge through you?',
      answer: 'We support you through the full SFP registration and trial process. Once Amazon approves your SFP application (we\'ll guide you), we fulfil your Prime orders using Amazon\'s approved carrier templates, provide 1-day or 2-day delivery via Amazon Buy Shipping Services and maintain your SFP performance metrics at 99%+ accuracy and on-time delivery. We process around 2,000 orders per day while consistently meeting Amazon\'s requirements.'
    },
    {
      id: 4,
      question: 'How will you prevent my Prime badge from being removed due to service provider issues?',
      answer: 'We currently fulfil around 2,000 Prime orders per day while consistently meeting or exceeding Amazon\'s SFP requirements: 99%+ on-time shipment rate, 98%+ Buy Shipping compliance and a cancellation rate well below Amazon\'s 0.5% threshold. Our entire operation is built around SFP compliance — it\'s not an add-on, it\'s our core speciality.'
    },
    {
      id: 5,
      question: 'Do I have to be an enrolled SFP seller already to work with you?',
      answer: (
        <>
          No. If you&apos;re not yet enrolled in Seller Fulfilled Prime, we&apos;ll help guide you through the
          application and trial process. We&apos;ll advise on meeting Amazon&apos;s{' '}
          <Link to="/blog/seller-fulfilled-prime-uk-requirements-expert-guide">
            SFP eligibility requirements
          </Link>
          , support you during the trial period and ensure your metrics are hit from day one so you keep the Prime
          badge long-term.
        </>
      ),
    },
  ];

  return (
    <FAQSection
      headingId="sfp-faq"
      className="faqs-section"
      title="Seller Fulfilled Prime UK FAQs"
      description="Answers to common questions about Seller Fulfilled Prime UK, Prime eligibility, Amazon SFP performance requirements, order fulfilment, and maintaining your Prime badge."
      faqs={faqs.map(({ question, answer }) => ({ question, answer }))}
    />
  );
};

export default SFPFaq;
